var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSendDisable = function SvgSendDisable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#Send_disable_svg__paint0_linear_647_43518)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.955 21.406l5.532-1.21c.494-.108.494-.284 0-.392l-5.532-1.21c-.33-.073-.65-.424-.716-.784l-1.106-6.052c-.1-.541.192-.792.65-.561l16.88 8.524c.304.154.304.404 0 .558l-16.88 8.524c-.458.23-.75-.02-.65-.561l1.106-6.052c.066-.36.387-.712.716-.784z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Send_disable_svg__paint0_linear_647_43518",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439AFF"
  })))));
};
export default SvgSendDisable;